/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-01-18 21:31:10
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-01-18 21:32:47
 */
import { fetch, fetchGet } from "@/utils/request";

export default {
  //获取用户审核列表
  getUserList(param) {
    return fetchGet("/user/page", param);
  },

  //用户审核操作
  applyUser(param) {
    return fetch("/user/apply", param);
  },
};
